import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let activeTokenKey = null;
export const setActiveTokenKey = (key) => { activeTokenKey = key; };

const storageKey = (key) => `hotspot_token:${key}`;
export const getToken = (key) => localStorage.getItem(storageKey(key ?? activeTokenKey));
export const setToken = (key, value) => localStorage.setItem(storageKey(key), value);
export const clearToken = (key) => localStorage.removeItem(storageKey(key ?? activeTokenKey));

// pilih token yang tersedia untuk toko: admin/superadmin dulu (mode pratinjau & bantu reseller), lalu reseller
export const pickStoreTokenKey = (slug) => {
  if (getToken(`admin:${slug}`)) return `admin:${slug}`;
  if (getToken("superadmin")) return "superadmin";
  return `reseller:${slug}`;
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = activeTokenKey ? getToken(activeTokenKey) : null;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const rp = (n) => `Rp ${Number(n ?? 0).toLocaleString("id-ID")}`;

// URL logo toko (publik). Kosong bila toko belum punya logo -> pakai branding default.
export const storeLogoUrl = (store) =>
  store?.logo_path ? `${API}/public/stores/${store.slug}/logo?v=${encodeURIComponent(store.logo_path)}` : "";

export function errMsg(e, fallback = "Terjadi kesalahan") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
}
